export default __webpack_public_path__ + "1df12ad.png";